import { TuiInput } from '@taiga-ui/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { TuiInputDate } from '@taiga-ui/kit';

@Component({
  selector: 'pxc-patient-edit-form',
  templateUrl: './patient-edit-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, TranslocoDirective, TuiInputDate, TuiInput],
})
export class PatientEditFormComponent {
  @Input() form: UntypedFormGroup;
}
